document.addEventListener('DOMContentLoaded', function () {
  const input = document.querySelector('.search-bar__input');
  const resultsBox = document.getElementById('predictive-search-results');

  if (!input || !resultsBox) return;

  input.addEventListener('input', function () {
    const query = input.value.trim();
    if (query.length < 2) {
      resultsBox.style.display = 'none';
      resultsBox.innerHTML = '';
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,variants.sku,variants.barcode,tag`)
      .then(res => res.json())
      .then(data => {
        const products = data.resources.results.products;
        if (!products.length) {
          resultsBox.innerHTML = `<div class="no-results">No results found.</div>`;
          resultsBox.style.display = 'block';
          return;
        }

        resultsBox.innerHTML = products.map(product => `
          <a href="${product.url}" class="predictive-search-item">
            <img src="${product.featured_image.url}" alt="${product.title}" class="predictive-search-img" />
            <div class="predictive-search-info">
              <p class="predictive-search-title">${product.title}</p>
                          </div>
          </a>
        `).join('');

        resultsBox.style.display = 'block';
      })
      .catch(err => {
        console.error('Predictive search error:', err);
        resultsBox.style.display = 'none';
      });
  });

  input.addEventListener('blur', () => {
    setTimeout(() => {
      resultsBox.style.display = 'none';
    }, 200);
  });

  input.addEventListener('focus', () => {
    if (resultsBox.innerHTML.trim() !== '') {
      resultsBox.style.display = 'block';
    }
  });
});
